<template>
  <div class="event-details">
    <date-icon :date="pointDetails.startAt" />
    <div class="ms-2">
      <template v-if="onlyShowStartAndEndDates">
        <date-range-details :start-date="pointDetails.startAt" :end-date="pointDetails.endAt" />
      </template>
      <template v-else>
        <date-details :date="pointDetails.startAt" />
        <template v-if="showEndTime">
          <time-range-details :start-date="pointDetails.startAt" :end-date="pointDetails.endAt" :time-zone="pointDetails.startTz" />
        </template>
        <template v-else>
          <time-details :date="pointDetails.startAt" :time-zone="pointDetails.startTz" />
        </template>
      </template>
      <location-details-with-icon :location="pointDetails.location" :venue="pointDetails.locationVenue" :hide-exact-location="hiddenAddress" />
      <virtual-event-details-with-icon v-if="pointDetails.virtual" />
    </div>
  </div>
</template>

<script>
import DateIcon from '../date-icon'
import LocationDetailsWithIcon from '@/components/location-details-with-icon'
import DateDetails from '@/components/date-details'
import DateRangeDetails from '@/components/date-range-details'
import TimeDetails from '@/components/time-details'
import TimeRangeDetails from '@/components/time-range-details'
import VirtualEventDetailsWithIcon from '@/components/virtual-event-details-with-icon'
import { isMultiDayEvent } from '../../helpers/event'
import isPresent from '../../helpers/is-present'

export default {
  components: { DateDetails, DateRangeDetails, DateIcon, LocationDetailsWithIcon,
                TimeDetails, TimeRangeDetails, VirtualEventDetailsWithIcon },
  props: {
    pointDetails: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      onlyShowStartAndEndDates: isMultiDayEvent(this.pointDetails),
      showEndTime: isPresent(this.pointDetails.endAt)
    }
  },

  computed: {
    hiddenAddress() {
      return this.pointDetails.hiddenAddress
    }
  }
}
</script>

<style lang="scss" scoped>
.event-details {
  display: flex;
}
</style>
